<template>
  <div>
    <div class="ticket myticket">
      <!-- ヘッダー -->
      <TheHeader :click-back-button-event="returnNativeApp" />

      <!-- MasterBook・Bookのキービューの背景画像 -->
      <MbImageDisp :url="masterBook.content.ticket_detail_image_url" />

      <!-- ブック詳細 タイトル・詳細 -->
      <!-- margin-bottomはTheBookFooter用 -->
      <div class="ticket-detail" style="margin-bottom: 150px">
        <!-- マスターブックタイトル・コメント -->
        <TheMyMbNameAndComment />

        <!-- チケット購入詳細 -->
        <TheMyTicketPurchaseDetails />

        <!-- リンク集 -->
        <TheMbLinkCollection />

        <hr />

        <!-- チケット規約 -->
        <TheMbImportantLinkCollection
          v-if="masterBook.content.terms_url"
          :url="masterBook.content.terms_url"
        />

        <!-- フッターの黄色枠 利用を終了するボタンとダイアログ-->
        <BFaceFinishButton v-if="isAbleToFinish" />
      </div>

      <!-- フッター -->
      <TheBookFooter />
      <!-- フッター -->
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import bookService from "@/services/book";

export default {
  name: "TemplateBook",
  setup() {
    const store = useStore();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const book = computed(() => store.getters["ticketing/book"]);

    const isAbleToFinish = computed(() =>
      bookService.checkIsAbleToFinish(masterBook.value, book.value)
    );

    return {
      masterBook,
      isAbleToFinish,
    };
  },
};
</script>
